export const callAllFns =
	(...fns) =>
	(...args) =>
		fns.forEach((fn) => fn && fn(...args));
